export const SPEC_GROUPS: { heading: string; rows: [string, string][] }[] = [
  {
    heading: "Optics",
    rows: [
      ["Type of build", "Machined Aluminum"],
      ["Magnification", "6×"],
      ["OBJECTIVE LENS DIAMETER", "16 mm"],
      ["Exit pupil", "2.7 mm"],
      ["Eye relief", "14 mm"],
      ["Diopter adjustment", "Right side"],
      ["Interpupillary distance", "30–82 mm"],
      ["OPTICAL SYSTEM", "BK-7 Roof Prism"],
      ["Lens coating", "Fully, multiple"],
      ["Focusing system", "Central focusing"],
    ],
  },
  {
    heading: "Field of view",
    rows: [
      ["True field of view", "8.3°"],
      ["Apparent field of view", "49.8°"],
      ["FIELD OF VIEW AT 1,000 METERS", "145 m"],
      ["Field of view at 1,000 yards", "438 ft"],
      ["Close focus limit", "3.2 m"],
      ["Light intensity", "7.1"],
      ["Twilight factor", "9.8 acc to ISO 14132-1\u00a0"],
    ],
  },
  {
    heading: "General",
    rows: [
      ["Colour", "Satin Black, Matte Silver, Matte Blue"],
      ["Finish", "Anodized Matte or Satin"],
      ["Length", "77 mm"],
      ["Width", "61 mm"],
      ["Height", "37 mm"],
      ["Weight", "145 g"],
      ["Eyepieces for spectacle wearers", "Yes"],
      ["Watertight", "No"],
      ["Strap fitting", "Loop connector, narrow"],
      ["Carrying case", "Included"],
    ],
  },
];

export const SPEC_HIGHLIGHTS: { value: string; label: string }[] = [
  { value: "6×", label: "Magnification" },
  { value: "16 mm", label: "OBJECTIVE LENS" },
  { value: "145 g", label: "Weight" },
  { value: "145 m", label: "FOV @ 1,000M" },
];
